/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ProfilesInvoicePrimaryPathParams, ProfilesInvoicePrimaryResponse } from '../types/ProfilesInvoicePrimary'

/**
 * PATCH /:organisation/profiles/:profile/invoice/primary
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::invoicePrimary
 */
export async function profilesInvoicePrimary(
	organisation: ProfilesInvoicePrimaryPathParams['organisation'],
	profile: ProfilesInvoicePrimaryPathParams['profile'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesInvoicePrimaryResponse>> {
	return axiosInstance.patch(`/${organisation}/profiles/${profile}/invoice/primary`, undefined, config)
}
